import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ToastContainer, Flip} from 'react-toastify';
import {IndexLink, Link} from 'react-router';
import {logout} from 'flows/session/reducer';
import config from 'config';

import './App.css';

import {WhiteButton} from '../components/Button';

export const App = ({children, isLoggedIn, onLogout}) => (
  <div styleName="main-container">
    <header styleName="header">
      <a href="/" data-test="nav_logo"><img styleName="logo" src="/images/logo.svg" alt="Cove." /></a>
        {isLoggedIn &&
          <section>
            <a href="#main-menu"
               role="button"
               id="main-menu-toggle"
               styleName="menu-toggle">
              <span><img src='/images/burger.svg' alt='Menu' /></span>
            </a>

            <nav id="main-menu" role="navigation" styleName="main-menu" aria-expanded="false" aria-label="Main menu">
              <a href="#main-menu-toggle"
                 role="button"
                 id="main-menu-close"
                 styleName="menu-close"
                 aria-expanded="false"
                 aria-controls="main-menu"
                 aria-label="Close main menu">
                <span>&times; close</span>
              </a>
              <ul>
                <li>
                  <IndexLink onClick={() => {window.location.hash = 'main-menu-toggle'}} to="/" activeStyle={{ color: '#4B4B4B', 'fontWeight': 'bold' }} data-test="nav_investments">investments</IndexLink>
                </li>
                <li>
                  <Link onClick={() => {window.location.hash = 'main-menu-toggle'}} to="/profile" activeStyle={{ color: '#4B4B4B', 'fontWeight': 'bold' }} data-test="nav_profile">profile</Link>
                </li>
                <li>
                  <a onClick={onLogout} data-test="nav_logout">
                    logout
                  </a>
                </li>
              </ul>
            </nav>
            <a href="#main-menu-toggle"
             className="backdrop"
             tabIndex="-1"
             hidden></a>
         </section>
        }
    </header>
    <div styleName="container">
      {children}
    </div>
    <ToastContainer transition={Flip} />
    <footer styleName="footer">

        <img src="/images/logo.svg" alt="Cove." styleName="footer_logo"/>

      <section>
        <p styleName="footer_copy">
          &copy; {new Date().getFullYear()} Cove Platform LLC
          <br />
          <a styleName="footer_terms" href={config.cove.toslink} target="_blank" data-test="footer_tos">
            Terms of Use
          </a>
          &nbsp;&amp;&nbsp;
          <a styleName="footer_terms" href={config.cove.privacylink} target="_blank" data-test="footer_policy">
            Privacy Policy
          </a>
        </p>
        <p>Need help? <a href="mailto:support@cove.io" data-test="footer_support">support@cove.io </a></p>
      </section>
    </footer>
  </div>
);

App.propTypes = {
  children: PropTypes.element.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
};

const mapStoreToProps = ({session}) => ({
  isLoggedIn: !!session.user.idToken,
});

const mapDispatchToProps = dispatch => (
  {
    onLogout: () => {
      dispatch(logout({
        sendToLogin: true,
      }));
    },
  }
);

export default connect(mapStoreToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./web/containers/App.js